import {
  faEdit,
  faGear,
  faSearch,
  faSignOut,
  faTShirt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
const Navbar = () => {
  const Navigate = useNavigate();

  const logoutSubmit = async (e) => {
    e.preventDefault();

    axios.post("/logout").then((res) => {
      if (res.data.status === 200) {
        localStorage.removeItem("auth_token");
        localStorage.removeItem("user");
        localStorage.removeItem("image");
        Navigate("/login", { replace: true });
      }
    });
  };
  return (
    <nav className="sb-topnav navbar navbar-expand bg-white">
      {/* Navbar Brand */}
      <Link className="navbar-brand ps-3" to="/admin">
        Admin Panel
      </Link>
      {/* Navbar Search */}
      <form className="d-none d-md-inline-block form-inline ms-auto me-0 me-md-3 my-2 my-md-0">
        <div className="input-group">
          <input
            className="form-control"
            type="text"
            placeholder="Search for..."
            aria-label="Search for..."
            aria-describedby="btnNavbarSearch"
          />
          <button className="btn btn-primary" type="button">
            <FontAwesomeIcon icon={faSearch} />
          </button>
        </div>
      </form>
      {/* Navbar */}
      <ul className="navbar-nav ms-auto ms-md-0 me-3 me-lg-4">
        <li className="nav-item dropdown">
          <Link
            to="#"
            className="nav-link dropdown-toggle"
            id="navbarDropdown"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {/* <FontAwesomeIcon icon={faUserAlt} /> */}
            <img
              src="https://www.dropbox.com/s/iv3vsr5k6ib2pqx/avatar_default.jpg?dl=1"
              style={{ width: "40px", height: "40px", borderRadius: "50%" }}
              alt="noimg"
            />
          </Link>
          <ul
            className="dropdown-menu dropdown-menu-end "
            style={{ width: "400px" }}
            aria-labelledby="navbarDropdown"
          >
            <div className="px-3 py-2">
              <div className="">
                <b>Good Morning</b>, Johne Doe
              </div>
              <span>Project Admin</span>

              <li className="p-2">
                <Link className="dropdown-item">
                  <FontAwesomeIcon icon={faGear} className="me-3" />
                  Settings
                </Link>
              </li>
              <li className="p-2">
                <Link className="dropdown-item">
                  <FontAwesomeIcon icon={faTShirt} className="me-3" />
                  Activity Log
                </Link>
              </li>
              <li className="p-2">
                <Link className="dropdown-item" to="/editor">
                  <FontAwesomeIcon icon={faEdit} className="me-3" />
                  Editor
                </Link>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li className="p-2">
                <Link className="dropdown-item" onClick={logoutSubmit}>
                  <FontAwesomeIcon icon={faSignOut} className="me-3" />
                  Logout
                </Link>
              </li>
            </div>
          </ul>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
